import { authenticationService } from '../services/authentication.service'

export const requestOptions = {
  get (body) {
    return {
      method: 'GET',
      ...headers(),
      data: JSON.stringify(body)
    }
  },
  post (body) {
    return {
      method: 'POST',
      ...headers(),
      body: JSON.stringify(body)
    }
  },
  postFormData (body) {
    return {
      method: 'POST',
      ...headersForm(),
      body: body
    }
  },
  patch (body) {
    return {
      method: 'PATCH',
      ...headers(),
      body: JSON.stringify(body)
    }
  },
  put (body) {
    return {
      method: 'PUT',
      ...headers(),
      body: JSON.stringify(body)
    }
  },
  delete () {
    return {
      method: 'DELETE',
      ...headers()
    }
  }
}

function headers () {
  const currentUser = authenticationService.currentUserValue || {}
  const authHeader = currentUser.access
    ? { Authorization: 'Bearer ' + currentUser.access }
    : {}
  return {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json'
    }
  }
}

function headersForm () {
  const currentUser = authenticationService.currentUserValue || {}
  const authHeader = currentUser.access
    ? { Authorization: 'Bearer ' + currentUser.access }
    : {}
  return {
    headers: {
      ...authHeader
      // 'Content-Type': 'multipart/form-data'
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/request-options.js